import {DefaultSchema} from '@/schema/DefaultSchema'
import {FieldSet} from '@simpli/meta-schema'
import {INntTagCollectionResourcesHolder} from '@/model/collection/NntTagCollection'
import {NntTag} from '@/model/resource/NntTag'

export class FilterNntTagSchema extends DefaultSchema
  implements INntTagCollectionResourcesHolder {
  readonly name = 'FilterNntTag'

  readonly fieldSet: FieldSet<NntTag> = {}
}
